if (!customElements.get('share-button')) {
  customElements.define(
    'share-button',
    class ShareButton extends DetailsDisclosure {
      constructor() {
        super();

        this.elements = {
          shareButton: this.querySelector('button'),
          shareSummary: this.querySelector('summary'),
          closeButton: this.querySelector('.share-button__close'),
          successMessage: this.querySelector('[id^="ShareMessage"]'),
          urlInput: this.querySelector('input'),
        };
        this.urlToShare = this.elements.urlInput ? this.elements.urlInput.value : document.location.href;
        this.isProductShare = this.hasAttribute('data-product-share');
        this.sharePending = false;

        if (this.isProductShare) {
          this.mainDetailsToggle.addEventListener('toggle', () => {
            if (this.mainDetailsToggle.open) this.updateUrl(this.productUrl());
          });
        }
        this.mainDetailsToggle.addEventListener('toggle', this.toggleDetails.bind(this));
        this.elements.closeButton.addEventListener('click', this.close.bind(this));
        this.mainDetailsToggle.querySelector('.share-button__copy').addEventListener('click', this.copyToClipboard.bind(this));

        if (navigator.share) {
          this.mainDetailsToggle.setAttribute('hidden', '');
          this.elements.shareButton.classList.remove('hidden');
          this.elements.shareButton.addEventListener('click', () => {
            if (this.isProductShare) this.shareProduct();
            else navigator.share({ url: this.urlToShare, title: document.title });
          });
        }
      }

      productUrl() {
        const base = new URL(this.urlToShare, document.location.origin);
        const current = new URL(document.location.href);
        const clean = new URL(base.pathname, base.origin);
        const sameProduct = current.pathname.split('/products/')[1] === base.pathname.split('/products/')[1];
        const variant = (sameProduct ? current.searchParams.get('variant') : null) || base.searchParams.get('variant');
        if (variant && /^\d+$/.test(variant)) clean.searchParams.set('variant', variant);
        if (sameProduct && this.closest('[data-fp-root]')) {
          const allowed = { fp_plan:/^(launch|growth|network)$/, fp_brand:/^[01]$/, fp_scope:/^[01]$/, fp_service:/^[012]$/ };
          for (const [key, pattern] of Object.entries(allowed)) {
            const value = current.searchParams.get(key);
            if (value !== null && pattern.test(value)) clean.searchParams.set(key, value);
          }
        }
        return clean.href;
      }

      async shareProduct() {
        if (this.sharePending) return;
        this.sharePending = true;
        this.updateUrl(this.productUrl());
        try {
          await navigator.share({ url:this.urlToShare, title:document.title });
        } catch (error) {
          if (error.name !== 'AbortError') {
            this.elements.shareButton.classList.add('hidden');
            this.mainDetailsToggle.removeAttribute('hidden');
            this.mainDetailsToggle.open = true;
            this.elements.urlInput.focus();
            this.elements.urlInput.select();
          }
        } finally {
          this.sharePending = false;
        }
      }

      toggleDetails() {
        if (!this.mainDetailsToggle.open) {
          this.elements.successMessage.classList.add('hidden');
          this.elements.successMessage.textContent = '';
          this.elements.successMessage.classList.remove('is-error');
          this.elements.closeButton.classList.add('hidden');
          this.elements.shareSummary.focus();
        }
      }

      async copyToClipboard() {
        if (this.isProductShare) this.updateUrl(this.productUrl());
        try {
          await navigator.clipboard.writeText(this.elements.urlInput.value);
          this.elements.successMessage.classList.remove('is-error');
          this.elements.successMessage.classList.remove('hidden');
          this.elements.successMessage.textContent = window.accessibilityStrings.shareSuccess;
          this.elements.closeButton.classList.remove('hidden');
          this.elements.closeButton.focus();
        } catch (error) {
          if (!this.isProductShare) return;
          this.elements.successMessage.classList.remove('hidden');
          this.elements.successMessage.classList.add('is-error');
          this.elements.successMessage.textContent = this.dataset.copyFailed;
          this.elements.urlInput.focus();
          this.elements.urlInput.select();
        }
      }

      updateUrl(url) {
        this.urlToShare = url;
        this.elements.urlInput.value = url;
      }
    }
  );
}
